const keys = {
  all: ['imports'],
  list: companyId => [...keys.all, 'list', { companyId }],
  detail: importId => [...keys.all, 'detail', Number(importId)],
  rows: (importId, status, pageNumber) => [...keys.all, 'rows', Number(importId), { status: status || null, pageNumber }],
  allRows: (importId, version) => [...keys.all, 'allRows', Number(importId), { version: version || null }],
  files: importId => [...keys.all, 'files', Number(importId)],
  fileList: (importId, status, search, pageNumber) => [...keys.files(importId), 'list', { status: status || null, search: search || null, pageNumber }],
  rollbackPreview: importId => [...keys.all, 'rollbackPreview', Number(importId)]
};

export default keys;
